import { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import BaseRouter from "./routes";
import Context from "./context";
import Login from "./components/features/Login/Login";
import PasswordResetPage from "./components/features/Login/PasswordResetPage/PasswordResetPage";

const siteSettings = {
  loginActivePage: "login", //login, reset, register
  manageActivePage: "overview", //overview, download, add, autopay, contact
  detailActivePage:'overview', //overview, renew, contact, add
  currentAccountId: null,
  currentAccount: null,
  isGasLeakOpen: false,
  isSidebarOpen: false,
  modal: null,
  chartData:[],
  paymentMethodsChanged: false,
  paymentMethods:[],
  accounts: [],
  defaultPayMethod: {
    type: 'card',
    paymentId: 0,
    customerId: 0
  }
};

export default function App() {
  const [contextState, setContextState] = useState({ ...siteSettings });
  let accessToken = localStorage.getItem("accessToken");
  let resetToken = localStorage.getItem("resetToken");
  
  return (
    <Context.Provider value={{ contextState, setContextState }}>
      <BrowserRouter>
        {resetToken ? (
          <PasswordResetPage />
        ) : accessToken ? (
          <BaseRouter />
        ) : (
          <Login />
        )}
      </BrowserRouter>
    </Context.Provider>
  );
}
